
import { computed, defineComponent, onMounted, PropType, reactive, ref } from 'vue'
import { RouteLocationMatched } from 'vue-router'
import NavigationItem from '@/layouts/components/NavigationItem.vue'
import NavigationDropdown from '@/layouts/components/NavigationDropdown.vue'
import { useStore } from 'vuex'
import { QSpinnerOval, QSpinnerRings, QSpinnerTail, useQuasar } from 'quasar'
import NavigationTabBar from '@/layouts/components/NavigationTabBar.vue'
import NavigationTabBarItem from '@/layouts/components/NavigationTabBarItem.vue'

export default defineComponent({
  name: 'PageBase',
  components: { NavigationTabBar, NavigationTabBarItem, NavigationItem, NavigationDropdown },
  props: {
    title: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: 'n'
      // default: '@/assets/icons/cards.svg'
    },
    activeView: {
      type: String,
      // required: true
    },
    hideNav: {
      type: Boolean,
    },
    parent: {
      type: Object as PropType<RouteLocationMatched>,
      required: true
    }
  },
  setup (props) {
    const $q = useQuasar()
    const $store = useStore()

    function showMenu () {
      $store.commit('App/ToggleDrawer')
    }

    onMounted(() => {
      void $store.commit('App/HideMobileNav', false)
    })

    return {
      showMenu,
      menuActive: computed(() => $store.getters['App/DrawerOpened']),
      topMenuHidden: computed(() => $store.getters['App/HideMobileNav']),
      filtersHidden: computed(() => $store.getters['App/HideFilters']),
      isMobile: computed(() => $q.screen.lt.sm)
    }
  }
})
